import * as t from "io-ts";
import { trailerTypeT } from "../types";
import nullable from "../nullable";
export const trackingVehicleT = t.strict({
    vehicleId: t.string,
    vehicleNumber: t.string,
    trailerType: trailerTypeT,
    driverId: nullable(t.string),
    routeId: nullable(t.string),
});
export const trackingVehiclesT = t.array(trackingVehicleT);
//# sourceMappingURL=vehicle.js.map